import { AxiosResponse } from 'axios';
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { AUTH_CONFIRM_BASE_ROUTH, AUTH_CONFIRM_PATHS } from '../../routes/AuthConfirmRouter';
import { PATHS } from '../../routes/CaiExperienceRouter';
import { CommunicationDatatActionTypes } from '../../types/actions/communication-data-action';
import { TemplateLinearTypeEnum, TemplateTypeEnum } from '../../types/commonTypes';
import { CaiCaseEnum, CommunicationDataType, CommunicationType, EventValueEnum, UserRoleEnum } from '../../types/communication/communicationDataType';
import { getBackendData, getBackendErrorCode, getBackendErrorCodeFromHttpErr, getBackendErrorMetadataFromHttpErr, hasBackendResponseErrors, sendGet, sendPost, ServerResponseType } from '../../utils/api';
import { computeBaremeInfo } from '../../utils/bareme.utils';
import { composeUrl, ERROR_CODES, getExpiredPathFromComm, isIpernaturale, navigateToUrl, tqError } from '../../utils/utils';
import { invokeSignatureEndAct, loadAniaErrorAct, loadAniaSuccessAct, loadCommunicationErrorAct, loadCommunicationSuccessAct, saveCommunicationEndAct, saveCommunicationErrorAct, saveCommunicationSuccessAct } from './actions';

import { toast } from 'react-toastify';
import { LINEAR_BASE_ROUTE, LINEAR_PATHS } from '../../routes/linearRouteConstants';
import { isExpired48h } from '../../utils/time.utils';
import { getJsonLocalStorageAppState } from '../../utils/utils.store';

const SIGNATURE_ERROR_MESSAGE = 'Errore in fase di richiesta firma. Si prega di riprovare';

/* istanbul ignore next */
export const ToastNotifyError = () => {
    tqError({
        errors_elements: [window?.location?.href],
        errors_id: ['cai:errore in fase di richiesta firma'],
        errors_messages: [SIGNATURE_ERROR_MESSAGE],
        errors_type: ['user']
    })

    toast.error(SIGNATURE_ERROR_MESSAGE, {
        position: "top-center",
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark",
    });
}

export const getStateCommunicationData = (state: any) => state.communicationData

/* istanbul ignore next */
export const getOptionalForceLocalStoragePath = () => {
    const localStorageAppState = getJsonLocalStorageAppState()
    return (localStorageAppState?.isForwarded && localStorageAppState?.forceLastPathname)
}

/* istanbul ignore next */
export const manageCommunicationGoToForcePath = (action: any, communicationRes: Partial<CommunicationDataType>,
    token: string) => {
    const payloadNavigate = action.payload?.navigate
    const lo_forcePath = getOptionalForceLocalStoragePath()
    if (payloadNavigate) {
        const _communication = communicationRes?.communication;
        if (lo_forcePath) {
            navigateToUrl(payloadNavigate, lo_forcePath)
        } else if (_communication?.forceLastPathname) {
            navigateToUrl(payloadNavigate, _communication.forceLastPathname)
        } else if (!_communication?.forceLastPathname && !_communication?.lastPathname) {
            const isLinearCommunication: boolean = _communication?.companyName === "LINEAR";
            const _path = isLinearCommunication ? LINEAR_PATHS : PATHS
            const _baseRoute = isLinearCommunication ? LINEAR_BASE_ROUTE : ''
            const newUrl = composeUrl(token, _path.WELCOME_FIRST_PAGE, _baseRoute)
            navigateToUrl(payloadNavigate, newUrl)
        }
    }
}

export const manageAuthAndConfirmNextPath = (payloadNavigate: any, _communication: Partial<CommunicationType>) => {
    /* istanbul ignore next */
    if (_communication?.lastPathname) {
        navigateToUrl(payloadNavigate, _communication.lastPathname)
    } else {
        /* istanbul ignore next */
        const newUrl = composeUrl(_communication.token, AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CLAIM, AUTH_CONFIRM_BASE_ROUTH)
        // const newUrl = '/auth-confirm/AA_B_CTP_AUTH_CONFIRM/authorize-confirm-claim'
        navigateToUrl(payloadNavigate, newUrl)
    }
}

/* istanbul ignore next */
export const manageCommunicationGoToPath = (action: any, communicationRes: Partial<CommunicationDataType>,
    token: string) => {
    const payloadNavigate = action.payload?.navigate
    const localStorageForcePath = getOptionalForceLocalStoragePath()
    if (payloadNavigate) {
        const _communication = communicationRes?.communication;
        /* istanbul ignore next */
        if (_communication?.type === TemplateTypeEnum.REALTIME_ACCETTAZIONE_CAI) {
            navigateToUrl(payloadNavigate, PATHS.REALTIME_ACCETTAZIONE_CAI)
        } else /* istanbul ignore next */ if (_communication?.type === TemplateTypeEnum.CONFIRM_AND_AUTHORIZE_USER) {
            manageAuthAndConfirmNextPath(payloadNavigate, _communication)
            // navigateToUrl(payloadNavigate, PATHS.REALTIME_ACCETTAZIONE_CAI)
        }
        else if (localStorageForcePath) {
            navigateToUrl(payloadNavigate, localStorageForcePath)
        } else if (_communication?.forceLastPathname) {
            navigateToUrl(payloadNavigate, _communication.forceLastPathname)
        } else if (_communication?.lastPathname) {
            navigateToUrl(payloadNavigate, _communication.lastPathname)
        } else {
            const newUrl = composeUrl(token, PATHS.WELCOME_FIRST_PAGE)
            navigateToUrl(payloadNavigate, newUrl)
        }
    }
}

export enum SignFolderOutcomeEnum {
    CAI_ABORT = 'CAI_ABORT',
    HRM_EXPIRE = 'HRM_EXPIRE',
    CAI_TWO_SIGNATURES = 'CAI_TWO_SIGNATURES',
    CAI_ONE_SIGNATURE = 'CAI_ONE_SIGNATURE',
    CAI_REFUSED_SIGNATURE = 'CAI_REFUSED_SIGNATURE',
    CAI_ZERO_SIGNATURES = 'CAI_ZERO_SIGNATURES',
}

export const SIGNATURE_RESULTS = [SignFolderOutcomeEnum.CAI_ONE_SIGNATURE, SignFolderOutcomeEnum.CAI_TWO_SIGNATURES, SignFolderOutcomeEnum.CAI_ABORT, SignFolderOutcomeEnum.HRM_EXPIRE]


/* istanbul ignore next */
export const linearManageCommunicationGoToPath = (action: any, communicationRes: Partial<CommunicationDataType>,
    token: string) => {
    const payloadNavigate = action.payload?.navigate
    const localStorageForcePath = getOptionalForceLocalStoragePath()
    if (payloadNavigate) {
        const _communication = communicationRes?.communication;
        const urlParams = new URLSearchParams(window?.location?.search || '')
        const isDriverContext = urlParams.get('driver') === 'true'
        
        if (_communication?.type === TemplateLinearTypeEnum.LINEAR_REALTIME_ACCETTAZIONE_CAI) {
            const newUrl = composeUrl(token, LINEAR_PATHS.LINEAR_REALTIME_ACCETTAZIONE_CAI_PAGE, LINEAR_BASE_ROUTE)
            return navigateToUrl(payloadNavigate, newUrl)
        }
        if (_communication?.lastPathname?.includes("driver=true") && !isDriverContext) {
            const newUrl = composeUrl(token, LINEAR_PATHS.END_TO_DRIVER_THANK_YOU_PAGE, LINEAR_BASE_ROUTE)
            return navigateToUrl(payloadNavigate, newUrl)
        }
        
        // SEZIONE SOLO AGGIUNTA DOCUMENTI
        //const isRequiringDocuments = _communication?.events?.find((ev: EventCommType) => SIGNATURE_RESULTS.indexOf(ev?.metadata?.outcome as SignFolderOutcomeEnum) >= 0)
        //const weAskedForASignature = _communication?.events?.find((ev: any) => [EventValueEnum.LINEAR_START_ONE_SIGNATURE, EventValueEnum.LINEAR_START_SIGNATURE_SEND_FOR_CTP_AUTH].includes(ev.value))
        //const weIgnoredCaiSection = _communication?.events?.find(el => el.value === EventValueEnum.LINEAR_IGNORED_CAI)
        

        if (_communication?.type === TemplateLinearTypeEnum.CONFIRM_AND_AUTHORIZE_USER) {
            if (_communication.events?.some(ev => ev.value === EventValueEnum.AUTH_CONFIRM_END_CANCEL)) {
                navigateToUrl(payloadNavigate, AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_END_CANCEL)
            }
            else {
                navigateToUrl(payloadNavigate, AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CLAIM)
            }
        }
        else if (localStorageForcePath) {
            navigateToUrl(payloadNavigate, localStorageForcePath)
        } else if (_communication?.forceLastPathname) {
            navigateToUrl(payloadNavigate, _communication.forceLastPathname)
        } else if (_communication?.lastPathname) {
            navigateToUrl(payloadNavigate, _communication.lastPathname)
        } else {
            const newUrl = composeUrl(token, LINEAR_PATHS.WELCOME_FIRST_PAGE, LINEAR_BASE_ROUTE)
            navigateToUrl(payloadNavigate, newUrl)
        }
    }
}

export function* handlePollingCommunicationCall(action: any) {
    /* avoid polling for template TemplateTypeEnum.CONFIRM_AND_AUTHORIZE_USER */
    const stateCommunicationData: CommunicationDataType = yield select(getStateCommunicationData);
    const { communication } = stateCommunicationData
    /* istanbul ignore next */
    if (communication?.type === TemplateTypeEnum.CONFIRM_AND_AUTHORIZE_USER) {
        return
    }

    const token = action.payload?.token
    try {
        let requestURL = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}`;
        /* istanbul ignore next */
        let res: AxiosResponse<ServerResponseType<any>> = yield call(sendGet, requestURL);

        if (!hasBackendResponseErrors(res)) {
            const communicationRes = getBackendData(res);
            manageCommunicationGoToForcePath(action, communicationRes, token)
        }
    } catch (err) {
        /* istanbul ignore next */
        console.error('Error while ')
    }
}

export function* handleLoadCommunicationCall(action: any) {

    const token = action.payload?.token

    try {
        let requestURL = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}`;
        let res: AxiosResponse<ServerResponseType<any>> = yield call(sendGet, requestURL);
        if (hasBackendResponseErrors(res)) {
            const errCode = getBackendErrorCode(res)
            yield put(loadCommunicationErrorAct(errCode));
        } else {
            const communicationRes = getBackendData(res);

            yield put(loadCommunicationSuccessAct(communicationRes));
            if (communicationRes?.communication?.companyName === "LINEAR") {
                linearManageCommunicationGoToPath(action, communicationRes, token)
            } else {
                manageCommunicationGoToPath(action, communicationRes, token)
            }
        }
    } catch (err) {
        /* istanbul ignore next */
        const errCode = getBackendErrorCodeFromHttpErr(err)
        /* istanbul ignore next */
        if (errCode === ERROR_CODES.TOKEN_EXPIRED || errCode === ERROR_CODES.TOKEN_FORCE_INVALIDATED) {    //TOKEN_FORCE_INVALIDATED

            const companyName = window.location.pathname.includes(LINEAR_BASE_ROUTE) ? "LINEAR" : ""
            const comm = new CommunicationType({ token, companyName })       //TODO distinguere la company name
            yield put(loadCommunicationSuccessAct({ communication: comm }));

            const errMetadata: any = getBackendErrorMetadataFromHttpErr(err)
            comm.type = errMetadata?.type
            const newUrl = getExpiredPathFromComm(comm, errCode)
            action.payload?.navigate && action.payload.navigate(newUrl)
        } else {
            /* istanbul ignore next */
            yield put(loadCommunicationErrorAct());
        }
    }
}

export function* handleLoadAniaCall(action: any) {
    const stateCommunicationData: CommunicationDataType = yield select(getStateCommunicationData);
    const { communication } = stateCommunicationData
    const token = communication?.token
    
    // Conversione da dd-mm-yyyy a yyyy-mm-dd
    let inc_data = communication?.inc_data;
    if (inc_data && /^\d{2}\/\d{2}\/\d{4}$/.test(inc_data)) {
        const [dd, mm, yyyy] = inc_data.split("/");
        inc_data = `${yyyy}-${mm}-${dd}`;
    }

    try {
        let requestURL = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}/ania-companies?incDate=${inc_data}`;
        let res: AxiosResponse<ServerResponseType<any>> = yield call(sendGet, requestURL);
        if (hasBackendResponseErrors(res)) {
            const errCode = getBackendErrorCode(res);
            yield put(loadAniaErrorAct(errCode));
        } else {
            const aniaRes = getBackendData(res);
            yield put(loadAniaSuccessAct(aniaRes));
        }
    } catch (err) {
        /* istanbul ignore next */
        yield put(loadAniaErrorAct());
    }
}

/* istanbul ignore next */
export function* handleInvokeSignatureCall(action: any) {
    const stateCommunicationData: CommunicationDataType = yield select(getStateCommunicationData);
    const { communication, ctp } = stateCommunicationData
    const token = communication?.token
    let signResult = false;

    try {
        let requestURL = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}`;

        if (communication.userRole === UserRoleEnum.USER_1 && communication.caiCaseEnum !== CaiCaseEnum.CASE_L) {
            requestURL = `${requestURL}/start-signature-process`
        } else {
            if (communication.caiCaseEnum === CaiCaseEnum.CASE_1B ||
                (communication.caiCaseEnum === CaiCaseEnum.CASE_2 && communication.userRole === UserRoleEnum.CTP) ||
                (communication.caiCaseEnum === CaiCaseEnum.CASE_1A && communication.userRole === UserRoleEnum.CTP) ||
                (communication.caiCaseEnum === CaiCaseEnum.CASE_L && communication.userRole === UserRoleEnum.CTP)) {
                requestURL = `${requestURL}/invoke-signature`
            } else if (communication.caiCaseEnum === CaiCaseEnum.CASE_2 && communication.userRole === UserRoleEnum.USER_1) {
                requestURL = `${requestURL}/case2-invoke-ctp-auth-and-sign`
            } else if (communication.caiCaseEnum === CaiCaseEnum.CASE_L && communication.userRole === UserRoleEnum.USER_1) {
                if (communication.linearControparteInfo.agreeWithCtp === true && !isExpired48h(communication?.creation_date)) {
                    requestURL = `${requestURL}/caseL-invoke-ctp-auth-and-sign`
                } else {
                    requestURL = `${requestURL}/invoke-mono-signature`
                }
            } else {
                requestURL = `${requestURL}/case1a-invoke-ctp-auth-and-sign`
            }
            if (isIpernaturale(communication) && ctp?.token) {
                requestURL = `${requestURL}?ctpToken=${ctp.token}`
            }
        }
        let res: AxiosResponse<ServerResponseType<any>> = yield call(sendGet, requestURL);
        if (hasBackendResponseErrors(res)) {
            ToastNotifyError();
        } else {
            signResult = true
            if (action.payload?.callback) {
                yield put(action.payload?.callback(res?.data))
            }
        }
        //console.log(res)
        yield put(invokeSignatureEndAct());
    } catch (err) /* istanbul ignore next */ {
        console.log(err)
        if (signResult === false) {
            ToastNotifyError();
        }
        yield put(invokeSignatureEndAct());
    }
}

export function* handleSaveCommunicationCall(action: any) {

    const stateCommunicationData: CommunicationDataType = yield select(getStateCommunicationData);
    const { communication } = stateCommunicationData
    const token = communication?.token
    const updatedCommunication = action.payload?.data

    if (action.payload?.computeBareme) {
        updatedCommunication.baremeInfo = computeBaremeInfo(updatedCommunication.baremeResponses)
    }

    const body = {
        communication: updatedCommunication,
        events: action.payload?.events
    }

    try {
        let requestURL = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}`;
        let res: AxiosResponse<ServerResponseType<any>> = yield call(sendPost, requestURL, body);
        /* istanbul ignore next */
        if (hasBackendResponseErrors(res)) {
            const errCode = getBackendErrorCode(res)
            yield put(saveCommunicationErrorAct(errCode));
        } else /* istanbul ignore next */ {
            // const communicationRes = getBackendData(res);
            if (action.payload?.data) {
                yield put(saveCommunicationSuccessAct(body));
            } else {
                yield put(saveCommunicationEndAct());
            }
            if (action.payload?.callback) {
                yield call(action.payload?.callback)
            }
        }
    } catch (err) {
        /* istanbul ignore next */
        yield put(saveCommunicationErrorAct());
    }
}

export function* watchLoadCommunicationRequest() {
    yield takeEvery([CommunicationDatatActionTypes.LOAD_COMMUNICATION], handleLoadCommunicationCall)
}
export function* watchExecutePollingRequest() {
    yield takeEvery([CommunicationDatatActionTypes.EXECUTE_POLLING], handlePollingCommunicationCall)
}
export function* watchLoadAniaRequest() {
    yield takeEvery([CommunicationDatatActionTypes.LOAD_ANIA], handleLoadAniaCall)
}
export function* watchInvokeSignatureRequest() {
    yield takeEvery([CommunicationDatatActionTypes.INVOKE_SIGNATURE], handleInvokeSignatureCall)
}
export function* watchSaveCommunicationRequest() {
    yield takeEvery([CommunicationDatatActionTypes.SAVE_COMMUNICATION, CommunicationDatatActionTypes.SAVE_COMMUNICATION_IN_BACKGROUND], handleSaveCommunicationCall)
}

export function* communicationDataSaga() {
    yield all([fork(watchLoadCommunicationRequest), fork(watchLoadAniaRequest),
    fork(watchSaveCommunicationRequest), fork(watchInvokeSignatureRequest),
    fork(watchExecutePollingRequest)])
}

export default communicationDataSaga;
